var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeOpen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 25.5 25.5"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 12703"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 12701"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.035 16.481a3.694 3.694 0 1 1 3.58-3.692 3.634 3.634 0 0 1-3.58 3.692",
  "data-name": "Path 5542"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.15 15.46a5.64 5.64 0 0 0 0-5.352c-2.29-3.713-5.58-5.858-9.11-5.858s-6.825 2.145-9.115 5.858a5.64 5.64 0 0 0 0 5.352c2.29 3.712 5.58 5.858 9.11 5.858s6.815-2.146 9.115-5.858",
  "data-name": "Path 5543"
})))));
export { SvgEyeOpen as ReactComponent };
export default __webpack_public_path__ + "static/media/eye_open.a88acdc11480b7f2dd42ce2ee007b5cc.svg";